import React from 'react'

function Loading() {
  return (
    <img className='absolute top-[70px] left-[70px] right-[70px] bottom-[70px] w-full ' src={'https://flevix.com/wp-content/uploads/2021/06/Electric-Loading.gif'} alt={"Loading"}/>
  )
}

export default Loading